// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon__I40qE","sourceItem":"style__sourceItem__i8240","placeholder":"style__placeholder__VyH02","dragDropHint":"style__dragDropHint__nOHik style__placeholder__VyH02"};